import {
  computed,
  ref,
  toRef,
} from "vue";

import AHttpAPI from "aloha-vue/src/compositionAPI/AHttpAPI";

import PuxTablePlugin from "../plugin/PuxTablePlugin";

import EventBus from "aloha-vue/src/utils/EventBus";
import {
  getModelFromAFiltersWithModelId,
} from "../utils/utils";
import {
  cloneDeep,
  forEach,
  get,
  isArray,
  isEqual,
  isPlainObject,
  isUndefined,
  map,
} from "lodash-es";

export default function LoadDataAPI(props, { emit }, {
  appliedModelFilters = ref({}),
  blockFirstLoad = ref(undefined),
  changeUrlBrowser = () => {},
  closePreviewAll = () => {},
  filtersKeyById = computed(() => ({})),
  limitLocal = ref(0),
  mainModelFilters = ref({}),
  modelSortLocal = ref(undefined),
  offsetLocal = ref(0),
  onErrorsByLoad = () => {},
  puxTableRef = ref(undefined),
  updateCsvOptionsLocal = () => {},
  updateMultipleActionsFromResponse = () => {},
  urlParamsMultipleAction = ref({}),
  usePaginationLocal = computed(() => false),
  useUrlParametersSorting = computed(() => false),
  viewCurrent = ref(undefined),
}) {
  const apiSaveId = toRef(props, "apiSaveId");
  const data = toRef(props, "data");
  const id = toRef(props, "id");
  const isPaginationOutside = toRef(props, "isPaginationOutside");
  const url = toRef(props, "url");
  const urlParams = toRef(props, "urlParams");
  const useCountApi = toRef(props, "useCountApi");

  const _isLoadingTableLocal = ref(undefined);
  const countAllRows = ref(0);
  const countParams = ref(undefined);
  const dataLocal = ref([]);
  const disabledAllActions = ref(false);
  const isLoadingTable = ref(true);
  const isReloadingTable = ref(false);
  const usesCountApi = ref(false);

  const {
    abortHttp,
    getHttp,
  } = AHttpAPI();

  const {
    isAuthenticated,
    user,
  } = PuxTablePlugin.UserAPI();

  const countAllRowsLocal = computed(() => {
    if (data.value) {
      return data.value.length;
    }
    return countAllRows.value;
  });

  const dataLocalComputed = computed(() => {
    if (data.value) {
      return data.value;
    }
    return dataLocal.value;
  });

  const filterObjectWithoutEmptyStrings = ({ obj }) => {
    forEach(obj, (item, key) => {
      if (item === "") {
        delete obj[key];
      }
    });

    return obj;
  };

  const urlParametersLocal = computed(() => {
    const MODEL_FILTERS = {
      ...appliedModelFilters.value,
      ...mainModelFilters.value,
    };

    let urlParameters = getModelFromAFiltersWithModelId({
      model: MODEL_FILTERS,
      filtersKeyById: filtersKeyById.value,
    });

    if (isPaginationOutside.value && usePaginationLocal.value) {
      urlParameters.limit = limitLocal.value;
      if (offsetLocal.value) {
        urlParameters.offset = offsetLocal.value;
      }
    }
    if (useUrlParametersSorting.value) {
      urlParameters.ordering = modelSortLocal.value;
    }
    const VIEW_URL_PARAMS = get(viewCurrent.value, "urlParams") || {};

    urlParameters = {
      ...urlParameters,
      ...VIEW_URL_PARAMS,
    };

    return filterObjectWithoutEmptyStrings({ obj: urlParameters });
  });

  const deleteDataLocal = () => {
    dataLocal.value = [];
  };

  const stopRenderRowsLocal = () => {
    puxTableRef.value && puxTableRef.value.stopRenderRows();
  };

  // setData({ data, params }) { // TODO: SmartTable
  //       this.dataLoaded = true;
  //       this.counter.total = data[GlobalOptions.tableOptions.keyCount];
  //       this.rows = data[GlobalOptions.getListHttpKeyList];
  //       if (GlobalOptions.tableOptions.csv) {
  //         const CSV_OPTIONS = {
  //           url: this.optionsClone.url,
  //           status: data.csv_available,
  //           csv_max_entries: data.csv_max_entries,
  //           title: `Suchergebnis als CSV-Datei herunterladen ${ data.csv_max_entries ? ` (maximal ${ data.csv_max_entries } Datensätze)` : "" }`,
  //           params: params,
  //           label: "",
  //         };
  //         this.csv = this.options.csv ? this.options.csv : CSV_OPTIONS;
  //       }
  //       if (isFunction(this.options.onRefreshCallback)) {
  //         this.options.onRefreshCallback({ params, rows: this.rows });
  //       }
  //       this.initMassActionsFromResponse({ data, params });
  //     },

  const saveUrlParametersInLocalStorage = urlParameter => {
    try {
      const PARAMETERS = cloneDeep(urlParameter);
      if (isAuthenticated.value) {
        PARAMETERS._userPk = user.value.pk;
      } else {
        PARAMETERS._userPk = "_anonymous";
      }
      localStorage.setItem(`${ id.value }_filter`, JSON.stringify(PARAMETERS));
    } catch (e) {

    }
  };

  const checkCountReload = ({ urlParametersForAPI, isUpdateCountAllowed }) => {
    const PARAMS = cloneDeep(urlParametersForAPI);
    delete PARAMS.limit;
    delete PARAMS.offset;

    if (isUpdateCountAllowed ||
      isUndefined(countParams.value) ||
      !isEqual(PARAMS, countParams.value)) {
      usesCountApi.value = false;
      countParams.value = PARAMS;
    } else {
      usesCountApi.value = true;
    }
  };

  const loadCount = ({ url, urlParams }) => {
    if (!useCountApi.value || usesCountApi.value) {
      return;
    }
    let COUNT_URL = "";
    if (url.includes("?")) {
      COUNT_URL = url.replace("?", "count/?");
    } else {
      COUNT_URL = `${ url }count/`;
    }
    return getHttp({
      url: COUNT_URL,
      urlParams,
      ignoreErrorHandler: true,
    }).then(
      response => {
        countAllRows.value = response;
        usesCountApi.value = true;
        checkRowsWithOffsetAfterLoad();
      }
    );
  };

  const loadData = ({ isUpdateCountAllowed } = {}) => {
    _isLoadingTableLocal.value = true;
    EventBus.$emit(`${ id.value }updateData`);
    changeUrlBrowser(urlParametersLocal.value);
    saveUrlParametersInLocalStorage(urlParametersLocal.value);

    if (blockFirstLoad.value) {
      blockFirstLoad.value = false;
      isLoadingTable.value = false;
      _isLoadingTableLocal.value = false;
      return;
    }

    const urlParametersForAPI = {
      ...urlParams.value,
      ...urlParametersLocal.value,
      ...urlParamsMultipleAction.value,
    };

    checkCountReload({ urlParametersForAPI, isUpdateCountAllowed });

    closePreviewAll();
    if (isArray(url.value)) {
      abortHttp({
        abortGroup: id.value,
      });
      stopRenderRowsLocal();
      setTimeout(() => {
        return Promise.all(map(url.value, item => getHttp({
          url: item,
          urlParams: urlParametersForAPI,
          showError: true,
        }))).then(
          response => {
            if (isArray(response)) {
              let count = 0;
              let results = [];
              forEach(response, item => {
                if (isArray(item)) {
                  count += item.length;
                  results = [...results, ...item];
                } else {
                  count += item.count;
                  results = [...results, ...item.results];
                }
              });
              countAllRows.value = count;
              dataLocal.value = results;
            } else {
              countAllRows.value = response.count;
              dataLocal.value = response.results;
            }
            emit("loadData", { response });
            setTimeout(() => {
              EventBus.$emit(`${ id.value }updateDataFinish`);
            });
            isReloadingTable.value = false;
            disabledAllActions.value = false;
            isLoadingTable.value = false;
            _isLoadingTableLocal.value = false;
          },
          error => {
            onErrorsByLoad(error);
            _isLoadingTableLocal.value = false;
          }
        );
      });
    } else if (url.value) {
      abortHttp({
        abortGroup: id.value,
      });
      stopRenderRowsLocal();
      setTimeout(() => {
        loadCount({
          url: url.value,
          urlParams: urlParametersForAPI,
        });
        return getHttp({
          url: url.value,
          urlParams: urlParametersForAPI,
          apiSaveId: apiSaveId.value,
          abortGroup: id.value,
        }).then(
          response => {
            if (isPlainObject(response)) {
              if (!usesCountApi.value) {
                countAllRows.value = response.count;
              }
              dataLocal.value = response.results;
              updateCsvOptionsLocal({ response, urlParams: urlParametersForAPI });
              updateMultipleActionsFromResponse({ response });
            } else if (isArray(response)) {
              countAllRows.value = response.length;
              dataLocal.value = response;
            }
            emit("loadData", { response });
            setTimeout(() => {
              EventBus.$emit(`${ id.value }updateDataFinish`);
            });
            isReloadingTable.value = false;
            disabledAllActions.value = false;
            isLoadingTable.value = false;
            _isLoadingTableLocal.value = false;
            checkRowsWithOffsetAfterLoad();
          },
          errors => {
            onErrorsByLoad(errors);
            _isLoadingTableLocal.value = false;
          }
        );
      });
    } else {
      isReloadingTable.value = false;
      disabledAllActions.value = false;
      isLoadingTable.value = false;
      _isLoadingTableLocal.value = false;
    }
  };

  const updateRow = ({ row, rowIndex }) => {
    if (data.value ||
      rowIndex > dataLocal.value.length - 1) { // Parent-Daten
      return;
    }
    dataLocal.value[rowIndex] = row;
    if (puxTableRef.value?.updateRow) {
      puxTableRef.value.updateRow({ row, rowIndex });
    }
  };

  const addRow = ({ row }) => {
    if (puxTableRef.value?.addRow) {
      puxTableRef.value.addRow({ row });
      countAllRows.value++;
    }
  };

  const deleteRow = ({ index }) => {
    if (puxTableRef.value?.deleteRow) {
      puxTableRef.value.deleteRow({ index });
      countAllRows.value--;
    }
  };

  function checkRowsWithOffsetAfterLoad() {
    if (!dataLocal.value?.length &&
      !_isLoadingTableLocal.value &&
      offsetLocal.value &&
      isPaginationOutside.value &&
      usePaginationLocal.value &&
      (offsetLocal.value >= countAllRows.value)) {
      const _offset = Math.floor((countAllRows.value - 1) / limitLocal.value) * limitLocal.value;
      if (_offset >= 0) {
        puxTableRef.value && puxTableRef.value.changeOffset(_offset);
      }
    }
  }

  return {
    addRow,
    countAllRowsLocal,
    dataLocalComputed,
    deleteDataLocal,
    deleteRow,
    disabledAllActions,
    isLoadingTable,
    isReloadingTable,
    loadData,
    updateRow,
    urlParametersLocal,
  };
}
